module.exports = __webpack_public_path__ + "assets/office.6bb2126c.svg";